<div class="bdo-container bdo-space--bottom">
  <h3>
    {{ 'payment.overview.title' | translate }}
  </h3>
</div>

<div class="re-copytext-with-margin bdo-container--single">
  {{ 'payment.overview.description' | translate }}
</div>

<div class="bdo-container--single bdo-space--bottom bdo-loading__wrapper" [class.bdo-loading__wrapper--height]="isLoading">
  @if (isLoading) {
    <bdo-loading></bdo-loading>
  }

  @if (paymentsData?.credits?.payments?.length > 0) {
    <ng-container *ngTemplateOutlet="tableDataTemplate; context: {
      $implicit:paymentsData?.credits,
      dataType: PaymentType.POSITIVE
    }"></ng-container>
  }

  @if (paymentsData?.receivables?.payments?.length > 0) {
    <ng-container *ngTemplateOutlet="tableDataTemplate; context: {
      $implicit:paymentsData?.receivables,
      dataType: PaymentType.NEGATIVE
    }"></ng-container>
  }

  @if (paymentsData?.futureReceivables?.payments?.length > 0) {
    <ng-container *ngTemplateOutlet="tableDataTemplate; context: {
      $implicit:paymentsData?.futureReceivables,
      dataType: PaymentType.FUTURE
    }"></ng-container>
  }

  @if (!isLoading && ((!paymentsData) || (paymentsData.receivables.payments.length + paymentsData.futureReceivables.payments.length + paymentsData.credits.payments.length === 0))) {
    <div>
      <div class="bdo-table max-space-tablet">
        <table class="tablet-up-only receivables">
          <thead>
            <tr>
              <th class="col--bigger">{{ 'payment.overview.type.negative.title' | translate }}</th>
              <th class="col--smaller">{{ 'payment.overview.table.dateDue' | translate }}</th>
              <th class="col--smaller">{{ 'payment.overview.table.amount' | translate }}</th>
              <th>{{'payment.overview.table.defer' | translate}}</th>
            </tr>
          </thead>
        </table>
        <bdo-no-data
          [text]="'payment.noData' | translate">
        </bdo-no-data>
      </div>
    </div>
  }

  @if (!showAll) {
    <bdo-more-button
      [label]="'general.action.showMore' | translate"
      (moreEvent)="showAll = true"
    ></bdo-more-button>
  }
</div>
<bdo-faqs
  [keyName]="'payment.faqs'"
  [params]="{ accountId: customerNumber }"
></bdo-faqs>

<ng-template #tableDataTemplate let-data let-dataType="dataType">
  <div class="bdo-container--single bdo-table bdo-space--bottom tablet-up-only">
    <table [ngClass]="{'space--bottom': showAll, 'receivables': dataType === PaymentType.NEGATIVE}" >
      <thead>
        <tr>
          <th class="col--bigger">
            @switch (dataType) {
              @case ('negative') {
                {{ 'payment.overview.type.negative.title' | translate }}
              }
              @case ('positive') {
                {{ 'payment.overview.type.positive.title' | translate }}
              }
              @case ('future') {
                {{ 'payment.overview.type.future.title' | translate }}
              }
              @default {
                {{ 'payment.overview.type.unknown.title' | translate }}
              }
            }
          </th>
          <th class="col--smaller">{{ 'payment.overview.table.dateDue' | translate }}</th>
          <th class="col--smaller">{{ 'payment.overview.table.amount' | translate }}</th>
          @if (dataType === PaymentType.NEGATIVE) {
            <th>{{'payment.overview.table.defer' | translate}}</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (payment of asPaymentsDataCreditsFiltered(data, dataType); track payment) {
          <tr>
            <td class="col--bigger">{{ payment?.title }}</td>
            <td class="bdo-font--monospace" [attr.data-qa]="'dateDue'">
              {{ payment.deferredTo ? (payment.deferredTo | date) : (payment?.dateDue | date) }}
            </td>
            <td class="bdo-font--monospace smaller">
              {{ payment?.amount | currency: 'EUR' }}
            </td>
            @if (dataType === PaymentType.NEGATIVE) {
              <td>
                @if (payment.deferredTo) {
                  <div class="re-flex re-flex-col re-flex-nowrap" [attr.data-qa]="'deferred'">
                    <div>
                      {{ 'payment.overview.table.deferred' | translate }}
                      <bdo-inline-tooltip>{{ 'payment.overview.table.deferredHint' | translate }}</bdo-inline-tooltip>
                    </div>
                    <div class="re-text-xxs">{{ 'payment.overview.table.deferredFrom' | translate }} {{payment?.dateDue | date}}
                    </div>
                  </div>
                }
                @if (payment.isDeferrable) {
                  <bdo-text-link-icon
                    [attr.data-qa]="'deferralLink'"
                    [customIconSrc]="'general.img.edit' | translate"
                    [linkText]="'payment.overview.table.defer' | translate"
                    [extraData]="{
                      payment: payment
                    }"
                    [routerUrl]="'verschieben/' + payment?.id"
                    [iconPosition]="'right'"
                    [tracking]="['Zahlungsübersicht', 'click', 'Später zahlen']"
                    [attr.ariaRole]="'button'"
                  ></bdo-text-link-icon>
                }
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>

  <div class="mobile-only" [ngClass]="{'space-bottom': showAll}">
    @for (payment of asPaymentsDataCreditsFiltered(data, dataType); track payment) {
      <div>
        <div class="re-mb-10">
          <div class="bdo-tile bdo-table-row__container--mobile re-py-20 re-mb-1">
            <div>
              <div class="bold">
                @switch (dataType) {
                  @case ('negative') {
                    {{ 'payment.overview.type.negative.title' | translate }}
                  }
                  @case ('positive') {
                    {{ 'payment.overview.type.positive.title' | translate }}
                  }
                  @case ('future') {
                    {{ 'payment.overview.type.future.title' | translate }}
                  }
                  @default {
                    {{ 'payment.overview.type.unknown.title' | translate }}
                  }
                }
              </div>
              {{ payment?.title }}
            </div>
            <div>
              <div class="bold">{{ 'payment.overview.table.dateDue' | translate }}</div>
              {{ payment?.dateDue | date }}
            </div>
            <div>
              <div class="bold">{{ 'payment.overview.table.amount' | translate }}</div>
              {{ payment?.amount | currency:'EUR' }}
            </div>
          </div>
          @if (payment.deferredTo || payment.isDeferrable) {
            <div class="bdo-tile bdo-table-row__container--mobile">
              @if (payment.deferredTo) {
                <div class="re-flex re-flex-row md:re-flex-col">
                  <div class="re-mr-5">{{ 'payment.overview.table.deferred' | translate }}</div>
                  <div class="re-text-xxs re-mr-5">{{ 'payment.overview.table.deferredFrom' | translate }} {{payment?.dateDue | date}}</div>
                  <bdo-inline-tooltip>{{ 'payment.overview.table.deferredHint' | translate }}</bdo-inline-tooltip>
                </div>
              }
              @if (payment.isDeferrable) {
                <bdo-text-link-icon
                  [customIconSrc]="'general.img.edit' | translate"
                  [linkText]="'payment.overview.table.defer' | translate"
                  [extraData]="{
                      payment: payment
                    }"
                  [routerUrl]="'verschieben/' + payment?.id"
                  [iconPosition]="'right'"
                  [tracking]="['Zahlungsübersicht', 'click', 'Später zahlen']"
                  [attr.ariaRole]="'button'"
                ></bdo-text-link-icon>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
</ng-template>
